module.exports = __webpack_public_path__ + "img/wire-1.af52d711.jpg";